module.exports = __webpack_public_path__ + "static/img/keitodama.d822bca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3kfan/keitodama.png
// module id = 6/7a
// module chunks = 0